var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    attrs: { rules: _vm.rules },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          return [
            _c("div", { staticClass: "w-full flex my-2" }, [
              _c(
                "label",
                { staticClass: "checkbox-label checkbox-label--team mt-1" },
                [
                  _c("input", {
                    class: _vm.classes,
                    attrs: {
                      name: _vm.name,
                      id: _vm.id,
                      type: _vm.type,
                      disabled: _vm.disabled
                    },
                    domProps: { value: _vm.value, checked: _vm.state },
                    on: { change: _vm.onChange }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark checkmark--team" })
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "ml-0 mt-1",
                domProps: { innerHTML: _vm._s(_vm.description) }
              })
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade" } }, [
              _c(
                "span",
                { staticClass: "text-red-600", attrs: { id: "error" } },
                [_vm._v(_vm._s(errors[0] ? _vm.errorText : null))]
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }